/* eslint-disable angular/timeout-service */
import './fullscreen-toggle.less';
import { keycodesModule } from '../../constants/keycodes';

export const FULLSCREEN_EVT_CHANGE = 'fullscreen.change';
export const FULLSCREEN_EVT_ENTER = 'fullscreen.enter';
export const FULLSCREEN_EVT_EXIT = 'fullscreen.exit';
export const FULLSCREEN_EVT_ESCAPE = 'fullscreen.escape';

export const fullscreenToggleComponentModule = angular
  .module('Q.components.fullscreen-toggle', [keycodesModule])

  .directive(
    'fullscreenToggle',
    function ($document, $window, $timeout, $rootScope, KeyCodes) {
      const BODY_FULLSCREEN_CLASS = 'fullscreen-active';
      const FULLSCREEN_CLASS = 'fullscreen-element';
      const activeElements = [];

      function isActiveElement(el) {
        return activeElements[0] && activeElements[0][0] === el[0];
      }

      function resize(isFullScreen) {
        $window.setTimeout(() => {
          angular.element($window).triggerHandler('resize');
        });
        $timeout(() => {
          $rootScope.$broadcast(FULLSCREEN_EVT_CHANGE, isFullScreen);
          $rootScope.$broadcast(
            isFullScreen ? FULLSCREEN_EVT_ENTER : FULLSCREEN_EVT_EXIT,
            isFullScreen,
          );
        });
      }

      function escapeAll($event) {
        if (activeElements.length && $event.which === KeyCodes.ESCAPE) {
          $rootScope.$broadcast(FULLSCREEN_EVT_ESCAPE);
        }
      }

      let escapeLinked = false;

      return {
        restrict: 'E',
        replace: true,
        scope: {
          target: '@',
          active: '=?',
        },
        template:
          '<a class="fullscreen-toggle" ng-class="{active:active}" tooltip="Toggle Full Screen" ng-click="toggleState()"><span class="icon"></span><span class="text-hide">Full Screen</span></a>',
        link: function (scope) {
          scope.active = !!scope.active;

          const getEl = () =>
            angular.element($document[0].getElementById(scope.target));

          function enterFullScreen() {
            const el = getEl();
            if (!escapeLinked) {
              $document.on('keydown', escapeAll);
              escapeLinked = true;
            }

            if (!isActiveElement(el)) {
              if (activeElements.length) {
                activeElements[0].removeClass(FULLSCREEN_CLASS);
              }
              activeElements.unshift(el);
            }
            el.addClass(FULLSCREEN_CLASS);
            $document.find('body').addClass(BODY_FULLSCREEN_CLASS);

            resize(true);
          }

          function exitFullScreen() {
            const el = getEl();
            if (activeElements.length && isActiveElement(el)) {
              activeElements.shift();
            }
            el.removeClass(FULLSCREEN_CLASS);
            if (activeElements.length) {
              activeElements[0].addClass(FULLSCREEN_CLASS);
            } else {
              // in a non-angular timeout to prevent $digest errors (seems to be related to the window.onResize event)
              $document.find('body').removeClass(BODY_FULLSCREEN_CLASS);
            }

            resize(false);

            if (activeElements.length === 0) {
              $document.off('keydown', escapeAll);
              escapeLinked = false;
            }
          }

          function _updateState() {
            if (scope.active) {
              enterFullScreen();
            } else {
              exitFullScreen();
            }
          }

          if (scope.active) {
            enterFullScreen();
          }

          scope.toggleState = () => {
            scope.active = !scope.active;
          };

          scope.$watch('active', function (newValue, oldValue) {
            if (oldValue !== newValue) {
              _updateState();
            }
          });

          scope.$on(FULLSCREEN_EVT_CHANGE, () => {
            scope.$applyAsync(
              () => (scope.active = getEl().hasClass(FULLSCREEN_CLASS)),
            );
          });

          scope.$on(FULLSCREEN_EVT_ESCAPE, () => {
            scope.$applyAsync(() => (scope.active = false));
          });
        },
      };
    },
  );
